var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.link}},[_c('img',{staticClass:"logo",attrs:{"src":_vm.image || _vm.eloomiLogoImageUrl,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }